"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(() => (0, styles_1.createStyles)({
    root: {
        display: 'grid',
        gridAutoRows: 'minmax(min-content, max-content)',
    },
}));
//# sourceMappingURL=grid-styles.js.map